export const OBSERVABLE_IGNORE_EVENT = Symbol('OBSERVABLE_IGNORE_EVENT');
const defaultErrorHandler = (...args) => {
    // eslint-disable-next-line no-console
    console.error(`Observable: Error when notifying observers`, ...args);
};
export class Observable {
    errorHandler;
    currentState = null;
    hasStateBeenInitialised = false;
    registeredObservers = [];
    constructor(errorHandler = defaultErrorHandler) {
        this.errorHandler = errorHandler;
    }
    getCurrentState() {
        return this.currentState;
    }
    registerObserver(observer, owner) {
        this.registeredObservers.push({ observer, owner });
    }
    unregisterObserver(observer) {
        const index = this.registeredObservers.findIndex((item) => item.observer === observer);
        if (index !== -1) {
            this.registeredObservers.splice(index, 1);
        }
    }
    unregisterObservers(owner) {
        this.registeredObservers = this.registeredObservers.filter((item) => item.owner !== owner);
    }
    reset() {
        this.currentState = null;
        this.hasStateBeenInitialised = false;
    }
    notifyObservers(newState) {
        const isNewStateUndefined = typeof newState === 'undefined';
        const isStatelessObservable = typeof this.currentState === 'undefined' && isNewStateUndefined;
        const adaptedState = newState;
        if (adaptedState !== OBSERVABLE_IGNORE_EVENT && (isStatelessObservable || this.currentState !== adaptedState)) {
            this.hasStateBeenInitialised = true;
            this.currentState = adaptedState;
            this.doNotify(this.registeredObservers, adaptedState);
        }
    }
    doNotify(observers, adaptedState) {
        if (!this.hasStateBeenInitialised) {
            return;
        }
        observers.forEach((item) => {
            try {
                item.observer(adaptedState);
            }
            catch (error) {
                this.errorHandler(error);
            }
        });
    }
}
//# sourceMappingURL=observable.js.map